import { Navigate } from 'react-router-dom'

export default function OpsIndex() {
  return <Navigate to="/ops/extraction" replace />
}
